// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TabContentTop_wrapper__3sfq6"};